module.exports = __webpack_public_path__ + "e79bfd88537def476913f3ed52f4f4b3.eot";


//////////////////
// WEBPACK FOOTER
// ./src/assets/css/material-icons/MaterialIcons-Regular.eot
// module id = 378
// module chunks = 135